import { render, staticRenderFns } from "./alipay-add.vue?vue&type=template&id=66c34ea2&scoped=true&"
import script from "./alipay-add.vue?vue&type=script&lang=js&"
export * from "./alipay-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c34ea2",
  null
  
)

export default component.exports